import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            retryOnMount: false,
            refetchOnWindowFocus: false,
        },
    },
})

const AppQueryProvider = ({ children }: React.PropsWithChildren<unknown>): JSX.Element => {
    return (
        <QueryClientProvider client={queryClient}>
            {children}
            <ReactQueryDevtools position="bottom" buttonPosition="bottom-left" />
        </QueryClientProvider>
    )
}

export default AppQueryProvider
